// Helper ROI dan garis hitung per kamera (permintaan Andra 29 Okt 2026, #975/#976).
//
// Sumber data: ./cameraRoi.json (koordinat ternormalisasi 0-1, asal kiri-atas).
// Nilai bawaan dari berkas itu; operator dapat menimpanya per kamera lewat
// localStorage (lihat lib/roiStore.js). Penyaringan deteksi yang SEBENARNYA
// dilakukan backend Space (/analyze, parameter `roi`) supaya semua jalur
// konsisten; fungsi di sini dipakai klien untuk pratinjau dan validasi.
//
// Fungsi murni, tanpa DOM, supaya bisa diuji dengan node (lihat tests/cameraRoi.test.mjs).

import DATA from './cameraRoi.json' with { type: 'json' };

export const CAMERA_ROI = DATA;

export const kameraRoi = (id) => DATA.kamera[id] || null;

// Daftar cincin poligon (bisa lebih dari satu) untuk kamera id.
export const poligonKamera = (id) => DATA.kamera[id]?.poligon || [];

// Daftar garis hitung (biasanya 2) untuk kamera id.
export const garisKamera = (id) => DATA.kamera[id]?.garis || [];

export const jarakKamera = (id) => DATA.kamera[id]?.jarak_m ?? null;

// Ray casting: titik di dalam cincin poligon (pairing ganjil).
export function titikDalamPoligon(px, py, cincin) {
  const n = cincin?.length || 0;
  if (n < 3) return false;
  let dalam = false;
  for (let i = 0, j = n - 1; i < n; j = i++) {
    const xi = cincin[i][0], yi = cincin[i][1];
    const xj = cincin[j][0], yj = cincin[j][1];
    if ((yi > py) !== (yj > py)) {
      const xPotong = ((xj - xi) * (py - yi)) / (yj - yi) + xi;
      if (px < xPotong) dalam = !dalam;
    }
  }
  return dalam;
}

// Titik tengah-bawah kotak [x1,y1,x2,y2].
export function tengahBawah(kotak) {
  return [(kotak[0] + kotak[2]) / 2, kotak[3]];
}

// Saring daftar kotak [x1,y1,x2,y2] (bisa piksel) dengan cincin ternormalisasi.
// kembalikan hanya kotak yang titik tengah-bawahnya di dalam salah satu cincin.
// Bila cincin kosong, kembalikan apa adanya (perilaku lama).
export function saringKotakRoi(kotakList, cincin, lebar, tinggi) {
  if (!cincin || !cincin.length) return kotakList;
  return kotakList.filter((k) => {
    const [px, py] = tengahBawah(k);
    const nx = px / lebar, ny = py / tinggi;
    return cincin.some((c) => titikDalamPoligon(nx, ny, c));
  });
}

// Data ROI efektif (bawaan ditimpa override operator) untuk kamera id.
export function roiEfektif(id, override) {
  const dasar = DATA.kamera[id] || { poligon: [], garis: [] };
  return {
    ...dasar,
    poligon: override?.poligon?.length ? override.poligon : dasar.poligon,
    garis: override?.garis?.length ? override.garis : dasar.garis,
  };
}
